import React from 'react';
import { Collapse } from 'antd';
import { CollapseProps as CollapseCopyProps } from 'antd/lib/collapse';

export type CollapseProps = CollapseCopyProps;

const ProCollapse: React.FC<CollapseProps> = (props) => {
  const { children, ...resProps } = props;

  return <Collapse {...resProps}>{children}</Collapse>;
};

export default ProCollapse;
